/**
 * Haversine distance between two lat/lng points in kilometers.
 */
export function haversineKm(
  a: { lat: number; lng: number },
  b: { lat: number; lng: number }
): number {
  const R = 6371; // Earth radius in km
  const toRad = (deg: number) => (deg * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

/**
 * SnapShotBox HQ coordinates (Mödling).
 */
export const HQ_GEO = { lat: 48.0856, lng: 16.2869 };

/**
 * Format kilometers as short, human-readable label.
 * <1 km → "<1 km", else rounded to nearest integer.
 */
export function formatKm(km: number): string {
  if (km < 1) return "<1 km";
  return `${Math.round(km)} km`;
}

/**
 * REGEL: Fuer alle Distanzanzeigen ab HQ gilt die echte Strassen-Fahrdistanz
 * (`distanceKmRoad`, via OSRM vorberechnet und in den Stadtdaten hinterlegt).
 * Die Haversine-Luftlinie ist nur Fallback, wenn kein Wert hinterlegt ist.
 */
export function cityDistanceKm(page: {
  geo?: { lat: number; lng: number };
  distanceKmRoad?: number;
}): number | null {
  if (typeof page.distanceKmRoad === "number") return page.distanceKmRoad;
  if (page.geo) return haversineKm(HQ_GEO, page.geo);
  return null;
}

/** Radius in km, innerhalb dessen die Anfahrt inkludiert ist. */
export const INCLUDED_TRAVEL_RADIUS_KM = 25;

/**
 * REGEL: Liefertext ohne jede Preisangabe. Bis 100 km inklusive,
 * darueber nur der Hinweis auf zusaetzlich verrechnete Mehrstrecke.
 */
export function deliveryNote(km: number | null, isEn: boolean): string | null {
  if (km === null) return null;
  if (km <= INCLUDED_TRAVEL_RADIUS_KM) {
    return isEn
      ? "Delivery included within 100 km"
      : "Anfahrt innerhalb von 100 km inklusive";
  }
  return isEn
    ? "First 100 km of travel included, additional distance is charged separately"
    : "Anfahrt inklusive der ersten 100 km, die Mehrstrecke wird zusätzlich verrechnet";
}
